export default __webpack_public_path__ + "static/project-slide-1-768-700-bcde04b4988e401eb41ad2abc5262576.webp";